import { useState } from "react"

import { fetchApi } from "@inmagik/react-crud"
import { Formik, getIn } from "formik"
import * as yup from "yup"
import { API_URL } from "../constants"
import { Button, H2, PasswordField } from "@inmagik/magik-ui"

const schema = yup.object().shape({
  password: yup
    .string()
    .required("Password è un campo obbligatorio")
    .min(8, "La password deve essere lunga almeno 8 caratteri."),
  repeatPassword: yup
    .string()
    .required("Conferma Password è un campo obbligatorio")
    .oneOf([yup.ref("password"), ""], "Le password non corrispondono."),
})

const initialValues = {
  password: "",
  repeatPassword: "",
}

export function ResetPassword() {
  const [confirm, setConfirm] = useState(false)
  // get token from qs
  const token = new URLSearchParams(window.location.search).get("token")
  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{
        backgroundImage: "url(/sfondo.png)",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        width: "100%",
        height: "100vh",
      }}
    >
      <Formik
        validationSchema={schema}
        initialValues={initialValues}
        enableReinitialize
        onSubmit={async (values) => {
          await fetchApi(API_URL + "/userbase/reset-password/", {
            method: "POST",
            body: JSON.stringify({
              ...values,
              token,
            }),
            responseType: "raw",
            headers: {
              "Content-Type": "application/json",
            },
          }).then((e) => {
            setConfirm(true)
          })
        }}
      >
        {({ handleSubmit, touched, errors, values, setFieldValue }) => (
          <form onSubmit={handleSubmit}>
            <div
              style={{
                borderRadius: "1rem",
                border: "1px solid #fafafa",
                background: "linear-gradient(145deg, rgba(255, 255, 255, 0.4) 2.91%, rgba(255, 255, 255, 0.8) 97.55%)",
                boxShadow: "0px 4px 24px -1px rgba(0, 0, 0, 0.15)",
                backdropFilter: "blur(10px)",
                display: "flex",
                width: "464px",
                padding: "32px",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                gap: "20px",
                height: "max-content",
              }}
            >
              <div className="d-flex flex-column align-items-center">
                <H2 className="text-center">Reset Password</H2>
              </div>
              <div>Inserisci la tua nuova password per completare il reset.</div>
              {!confirm && (
                <div className="w-100">
                  <PasswordField
                    label="Password"
                    value={values.password}
                    onChange={(value) => {
                      setFieldValue("password", value)
                    }}
                    placeholder="Inserisci la tua password"
                    required
                    className="mb-2"
                    errorMessage={getIn(errors, "password")}
                    isValid={getIn(errors, "password") ? false : undefined}
                  />

                  <PasswordField
                    label="Conferma Password"
                    value={values.repeatPassword}
                    placeholder="Conferma la tua password"
                    required
                    onChange={(value) => {
                      setFieldValue("repeatPassword", value)
                    }}
                    errorMessage={getIn(errors, "repeatPassword")}
                    isValid={getIn(errors, "repeatPassword") ? false : undefined}
                  />
                </div>
              )}
              <div>
                {confirm && <div className="alert alert-success mt-2 py-1">Password modificata con successo.</div>}
              </div>
              {confirm ? (
                <Button
                  variant="primary"
                  className="w-100 mt-4 text-white d-flex align-items-center justify-content-center"
                  onClick={() => {
                    window.location.href = "/login"
                  }}
                  title="Vai al login"
                />
              ) : (
                <Button
                  type="submit"
                  className="w-100 mt-4 text-white d-flex align-items-center justify-content-center"
                  size="md"
                  variant="primary"
                  title="Reset Password"
                />
              )}
            </div>
          </form>
        )}
      </Formik>
    </div>
  )
}
